import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import importDirective from '@/directive';
import VueLazyload from 'vue-lazyload'; // 图片懒加载插件
import vuescroll from 'vuescroll'; // 移动端滚动插件
import 'vue-happy-scroll/docs/happy-scroll.css';

Vue.use(ElementUI);
Vue.use(vuescroll);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
})

//日期
import moment from 'moment';
Vue.prototype.$moment = moment;
moment.locale('zh-cn');

/**
 * 注册指令
 */
importDirective(Vue);
Vue.prototype.bus = new Vue();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
